import React from 'react';
import { TableFriendlyName } from '../../store/info/types';
import { Submission } from '../../store/submission/types';
import MyGridRedux from '../../components/MyGridRedux/MyGridRedux';
import { AppState } from '../../store/state';
import { selectInfo, selectKeywordState, selectSubmissionState } from '../../store/selectors';
import { AppDispatch } from '../../store/store';
import { connect } from 'react-redux';
import Loading from '../../components/Loading/Loading';
import { getSubmissionRow } from '../../helpers/table';
import { useTranslation } from 'react-i18next';
import useFetchTableData from '../../store/table/useFetchTableData';

interface Props {
  loading: boolean;
  submissionsById: { [key: string]: Submission };
  keywordById: { [key: number]: Keyword };
}

const PapersToReviewersPage: React.FC<Props> = ({ loading, submissionsById, keywordById }) => {
  const { t, i18n } = useTranslation();
  const friendlyName: TableFriendlyName = 'papers_to_reviews';
  const [fetchData, fetchCustomColumnsData] = useFetchTableData(friendlyName);

  if (loading) {
    return <Loading />;
  }

  const inputData: unknown[] = [];
  Object.values(submissionsById).forEach((submission, index) => {
    const newRegister = {
      ...getSubmissionRow(submission, true, keywordById, t),
    };

    inputData.push(newRegister);
  });

  return (
    <>
      <div className="h-full">
        {loading ? (
          <Loading />
        ) : (
          <MyGridRedux
            friendlyName={friendlyName}
            inputData={inputData as Record<string, unknown>[]}
            getInfoAction={fetchData}
            getCustomColumnsData={fetchCustomColumnsData}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  loading: selectInfo(state).loading || selectSubmissionState(state).loading,
  submissionsById: selectSubmissionState(state).submissionsById,
  keywordById: selectKeywordState(state).keywordById,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PapersToReviewersPage);
